import WpComments from "./wpComments";

export default WpComments;
export { WpComments };